const getProductChangeOfAddress = (state) => {
	return state;
};

const getProductChangeOfAddressShoppingCartId = (state) => {
	return state.shoppingCartId;
};

const getProductChangeOfAddressStatus = (state) => {
	return state.status;
};

export default {
	getProductChangeOfAddress,
	getProductChangeOfAddressShoppingCartId,
	getProductChangeOfAddressStatus
};
